// THE SECOND DEVICE'S APPROVAL OF A PAYOUT (N-068 — behind its switch, OFF by default), on the approval review.
// screens/custody/Approvals.tsx ApproveOnLedger's states, copied: the device's step, then the outcome — done, unknown
// (the device signed and the answer was lost: "check the list before approving again", with Check again), unrecorded
// (the window passed and the list still shows it open), failed (refusals.ts approvalOutcome) — and the button only
// where pressing again can help. The hook (useCardApproval) is the screen's own, imported.
import type { ApprovalRow } from '../../../lib/api';
import type { CardApproval } from '../../../screens/custody/Approvals';
import { approvalOutcome, approvalUnknownDetail } from '../../../screens/custody/refusals';
import { StateLine } from '../kit';

export function ApproveSecond({ a, approval }: { a: ApprovalRow; approval: CardApproval | null }) {
  if (approval === null) {
    return <StateLine more="The second device approves by cable: open this page in Brave or Edge on the computer it is plugged into.">Awaiting the second device.</StateLine>;
  }
  const end = approval.ended[a.txid] ?? null;
  if (end?.at === 'done') {
    return <StateLine tone="good" more="The desk sends the payout once it is signed as well. The list shows who approved it on its next read.">Approved — the list refreshes.</StateLine>;
  }
  if (end?.at === 'unknown') {
    return (
      <StateLine tone="warn" more={approvalUnknownDetail(end.error)}
        action={<button type="button" className="btn-link tap-44 text-body" onClick={approval.check}>Check again</button>}>
        Not confirmed — check the list before approving again.
      </StateLine>
    );
  }
  const outcome = end?.at === 'unrecorded'
    ? { line: 'Not recorded — approve again.', tone: 'bad' as const, retry: true, detail: 'The attempt\'s ten minutes have passed and the list still shows this card open: the desk did not record that approval, and cannot now.' }
    : end?.at === 'failed' ? approvalOutcome(end.error) : null;
  const mine = approval.busy === a.txid;
  return (
    <div className="space-y-2">
      {/* words:ok — the device's own step, as ledger-cable words it */}
      {mine && approval.step && <StateLine>{approval.step}</StateLine>}
      {/* words:ok — the outcome's one line (refusals.ts approvalOutcome) */}
      {outcome && <StateLine tone={outcome.tone} more={outcome.detail ?? undefined}>{outcome.line}</StateLine>}
      {(outcome === null || outcome.retry) && (
        <button type="button" onClick={() => approval.start(a)} disabled={approval.busy !== null} className="btn-secondary w-full px-4 text-body"
          title="Sign the approval message on this Ledger — the other device, not the one that signs the transaction">
          {mine ? 'On the Ledger…' : outcome ? 'Approve again' : 'Approve on second device'}
        </button>
      )}
    </div>
  );
}
